import React from "react";
import { Button } from "react-bootstrap";
import AppDialog from "@/components/ui/AppDialog";
import { useTheme } from "@/providers/theme-provider";

interface LogoutConfirmationModalProps {
    show: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({
    show,
    onConfirm,
    onCancel,
}) => {
    const { theme } = useTheme();
    const isDark = theme === "dark";

    return (
        <AppDialog
            show={show}
            onHide={onCancel}
            title="Log out"
            size="md"
            backdrop="static"
            footer={
                <div
                    className="d-flex justify-content-end gap-3 w-100"
                    style={{ padding: "0 32px 24px 32px", border: "none" }}
                >
                    <Button
                        variant="outline-primary"
                        onClick={onCancel}
                        style={{
                            borderRadius: "8px",
                            padding: "8px 20px",
                            fontSize: "14px",
                            fontWeight: "500",
                            minWidth: "100px",
                            height: "auto",
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={onConfirm}
                        style={{
                            borderRadius: "8px",
                            padding: "8px 20px",
                            fontSize: "14px",
                            fontWeight: "500",
                            minWidth: "100px",
                            height: "auto",
                            backgroundColor: "#007bff",
                            borderColor: "#007bff",
                        }}
                    >
                        Log out
                    </Button>
                </div>
            }
        >
            <div style={{ padding: "32px 32px 16px 32px" }}>
                <div className="text-center">
                    <h4
                        style={{
                            fontSize: "20px",
                            fontWeight: "600",
                            color: isDark ? "#e0e0e0" : "#212529",
                            marginBottom: "24px",
                            lineHeight: "1.3",
                        }}
                    >
                        Are you sure you want to log out?
                    </h4>
                    <div
                        style={{
                            fontSize: "14px",
                            lineHeight: "1.5",
                            color: isDark ? "#adb5bd" : "#6c757d",
                            marginBottom: "0",
                        }}
                    >
                        <p style={{ marginBottom: "4px" }}>
                            You&apos;ll be signed out of your account and will
                            no longer receive in-app alerts or notifications.
                        </p>
                        <p style={{ marginBottom: "0" }}>
                            If you&apos;ve enabled push notifications, you may
                            still receive them on your device.
                        </p>
                    </div>
                </div>
            </div>

            {/* Override default modal footer border */}
            <style jsx>{`
                :global(.modal-footer) {
                    border-top: none !important;
                    padding: 0 !important;
                }
            `}</style>
        </AppDialog>
    );
};

export default LogoutConfirmationModal;
